import { QueryClient } from "@tanstack/react-query"

export const createQueryClient = (retries = 3) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60, // 1 minutes
        retry: retries,
        refetchOnWindowFocus: false,
      },
    },
  })
